import htmlToDom from '../../../../helpers/htmlToDom';

export default ({ imageUrl, name }) =>
	htmlToDom(`
		<li class="modal__address-worker">
			<img class="modal__address-img" alt="worker photo" loading="lazy" style="height: 64px; width: 64px" src="${imageUrl}">
			<span class="modal__address-name">${name}</span>
		</li>
	`);
